function mutateCard(data, state) {
  return data.map(card => mutatePost(card, state));
}

function mutatePost(card, state) {
  const card$1 = key => state.card[key];
  const card$2 = (key, index) => state.card[key][index];
  return {
    ...card,
    author_phone: {
      number: card.author_phone.number,
      icon: card$1("author_phone").icon,
      label: card$1("author_phone").label
    },
    contact_types: [
      ...card.contact_types.map((contact, index) => ({
        ...contact,
        label: card$2("contact_types", index).label,
        icon: card$2("contact_types", index).icon
      }))
    ]
  };
}

function mutateFilter(filters) {
  return filters.map(filter => ({
    ...filter,
    value: filter.default,
    expanded: false
  }));
}

export default {
  state: {
    /**
     * Список всех постов и их количество
     */
    cards: [],
    post: {},
    totalCount: "",
    currentPage: "",
    perPage: 10,
    /**
     * Список всех фильтров
     */
    filters: [],
    category: 1,
    region: "",
    type: "",
    /**
     * Дополнительные поля для карточки
     */
    card: {
      id: null,
      author_phone: {
        label: "Связаться по номеру телефона",
        icon: require("@/assets/images/27zlrcb8QANKHoYh4sjTKI.svg")
      },
      contact_types: [
        {
          label: "Связаться по WhatsApp",
          icon: require("@/assets/images/zpsO96_YFj-TuJx4JXAi0.svg")
        },
        {
          label: "Связаться по Telegram",
          icon: require("@/assets/images/276FnaspW-gic1_UQ8xkXT.svg")
        }
      ]
    }
  },
  actions: {
    /**
     * Получает список всех постов и их общее количество
     */
    async fetchCards({ commit, state }, { API, page = "", type = "" }) {
      try {
        const response = await fetch(
          `${API}/materials/list?page=${page}&pageSize=${
            state.perPage
          }&category_id=${state.category}&type_id=${type ||
            state.type}&region_id=${state.region}`
        );

        const { content, pagerInfo } = await response.json();
        const materialsCount = pagerInfo?.materialsCount;
        const currPage = pagerInfo?.currPage;
        state.totalCount = materialsCount;
        state.currentPage = +currPage;
        commit("pushPostsHelp", mutateCard(content, state));

        return response;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    /**
     * Получает пост с сервера
     */
    async fetchCard({ commit, state }, { API, id }) {
      try {
        const response = await fetch(`${API}/materials/${id}`);
        const { content } = await response.json();
        commit("pushPostHelp", mutatePost(content, state));
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    /**
     * Получает список всех фильтров
     */
    async fetchFiltersList({ commit }, { locale, url }) {
      try {
        const response = await fetch(
          `https://admin.helpcenter.life${locale}/api/v1/${url}`
        );
        const filters = await response.json();
        commit("fetchFiltersList", mutateFilter(filters));
      } catch (e) {
        console.error(e);
        throw e;
      }
    }
  },
  mutations: {
    /**
     * Добавляет карточки на страницу
     */
    pushPostsHelp(state, card) {
      state.cards = [...card];
    },
    /**
     * Добавляет запись в state
     */
    pushPostHelp(state, post) {
      state.post = post;
    },
    /**
     * Показывает список всех фильтров
     */
    fetchFiltersList(state, filters) {
      state.filters = [...filters];
    },
    /**
     * Сброс фильтров по умолчанию
     */
    resetFilters(state) {
      state.category = 1;
      state.type = "";
      state.region = "";
    },
    /**
     * Определяет текущую таксономию
     */
    defineFilterId(state, { name, id }) {
      switch (name) {
        case "Категории":
          state.category = id;
          break;
        case "Могу помочь / нужна помощь":
          state.type = id;
          break;
        case "Выберите город":
          state.region = id;
          break;
      }
    },
    /**
     * Добавляет дополнительные поля в formData для отправки на сервер
     */
    getPostId(state, id) {
      state.card.id = id;
    }
  },
  getters: {
    cards: state => state.cards,
    post: state => state.post,
    totalCount: state => state.totalCount,
    currentPage: state => state.currentPage,
    perPage: state => state.perPage,
    id: state => state.card.id,

    filters: state => state.filters
  }
};
